import { injectable } from 'tsyringe';

import type {
  CourseData,
  CoursesListGateway,
} from '@/application/interfaces/course-list.interface';

@injectable()
export class FlowpressCoursesListGateway implements CoursesListGateway {
  async getCoursesList(): Promise<CourseData[]> {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FLOWPRESS_PATH}/faculdade-courses-list/`,
      );
      const json = await response.json();

      return json?.courses;
    } catch (error) {
      return [];
    }
  }
}
